import React, { useState, useMemo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShimmerThumbnailImage } from "../shimmerImage/shimmerImage";
import NoContentFound from "../../not-found/notFound";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import SearchForm from "../../search/searchForm";
import { GetGalleryItems, GetUnsplashItems } from "../../../../store/actions/new/galleryAction";



const UnsplashPhoto = ({ setImageSrc }) => {
    
    const [hasLoaded, setHasLoaded] = useState(false);
    const allData = useSelector((state) => state.galleryAllData);
    const { unsplashData, error, isLoading } = allData;
    const { data, pagination } = unsplashData;
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();

    const dispatch = useDispatch();
    useEffect(() => {
        if (!hasLoaded) {
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchPhoto();
        }
        prevSearchTermRef.current = searchTerm;

    }, [ data, searchTerm])

    const searchPhoto = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(GetUnsplashItems(postData));
        setLoading(false);
    }

    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(GetUnsplashItems(postData));
        }
    };

    const handleImageClick = (image) => {
        if (image) {
            setImageSrc(image.url);
        }
    };

    return (
        <div className="gallery-wrapper">
            <div className="search-container">
                <SearchForm
                    placeholder='Search card...'
                    loading={loading}
                    onChange={async (val) => {
                        setSearchTerm(val);
                    }}
                />
            </div>
            {Array.isArray(data) && data.length > 0 && (
                <div className="image-grid">
                    {data.map((image, i) => (
                        <div key={i} className="image-item" onClick={() => handleImageClick(image)}>
                            <ShimmerThumbnailImage
                                src={image.url ? image.url : `image not found`}
                                alt={image.caption}
                                fitOnFrame={true}
                            />
                            <div className="image-caption">{image.caption}</div>
                        </div>
                    ))}
                </div>
            )}
            <>
                { !isLoading && !searchTerm && Array.isArray(data) && data.length === 0 && (
                    <NoContentFound title="Search for the type of image you want above — the related image will appear here." />
                )
                }
                { !isLoading && searchTerm && Array.isArray(data) && data.length === 0 && (
                    <NoContentFound title="Result not found!" />
                )
                }
                {isLoading &&
                    <>
                        <ShimmerSimpleGallery row={2} col={4} imageHeight={140} />
                    </>
                }
                {!isLoading && pagination && pagination.page_last > pagination.page && (
                    <div className="load-more-container">
                        <button
                            className="load-more-btn"
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}
            </>
            
        </div>
    );
}

export default UnsplashPhoto;
